import { Action } from "../../../actions/actions";

const initialState: boolean = false;

export function loadingReducer(state = initialState, action: Action) {
    switch (action.type) {
        default:
            return state;
    }
}
